import getEnvironment from "./getEnviroment";

const getTextEnv = () => {
    return getEnvironment() === 'development' ? '🔥 DEV' : '🧪 {BITBUCKET_BRANCH}';
  }

export default getTextEnv;